import { Typography } from '@mui/joy';

interface PageTitleProps {
	subTitle: string;
}

export const PageSubTitle = ({ subTitle }: PageTitleProps) => {
	return (
		<Typography level='h1' sx={{ fontWeight: 300, marginTop: '15px' }}>
			{subTitle}
		</Typography>
	);
};
